var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.results),function(result){return _c('li',{key:result.text},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.select(result)}}},[_vm._v(" "+_vm._s(result.text)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }